<esn-page-header
  title="Help Center"
  subtitle="Answers to the questions this console gets asked, and the ways through to a person"
/>

<div class="help">
  <div class="help__main">
    <esn-faq-finder
      heading="Frequently asked"
      description="Search every answer, or open the subject you need."
      placeholder="Search the help topics"
      [countLabel]="countLabel()"
      [query]="query()"
      (queryChange)="onQuery($event)"
    />

    @if (subjects().length) {
      <div class="help__subjects">
        @for (subject of subjects(); track subject.id) {
          <esn-faq-group
            [heading]="subject.heading"
            [items]="subject.items"
            [multiple]="searching()"
            [open]="open()"
            (openChange)="open.set($event)"
          />
        }
      </div>
    } @else {
      <esn-empty-state
        class="help__no-results"
        variant="no-results"
        [title]="'No answers match “' + query().trim() + '”'"
        text="Nothing has been removed — the list is filtered. Clear it to see everything again."
      >
        <esn-button variant="secondary" (clicked)="clearSearch()">Clear search and filters</esn-button>
      </esn-empty-state>
    }

    <esn-feedback-form
      heading="Send feedback"
      description="Something broken, something missing, or something you cannot find — it all comes to the same team."
      kindLabel="What this is about"
      [kinds]="kinds"
      [(kind)]="feedbackKind"
      subjectLabel="Subject"
      subjectPlaceholder="One line — what this is about"
      [(subject)]="feedbackSubject"
      detailsLabel="Details"
      detailsPlaceholder="What were you doing, what did you expect, and what happened instead?"
      detailsHint="Screen names and what you clicked are the two things that save a round trip."
      [(details)]="feedbackDetails"
      replyToLabel="We will reply to"
      [replyTo]="replyTo()"
      clearLabel="Clear"
      submitLabel="Send feedback"
      (submit)="sendFeedback($event)"
    />
  </div>

  <esn-contact-card
    class="help__aside"
    heading="Talk to us"
    [description]="contact.hours"
    [channels]="contact.channels"
    [facts]="facts()"
    tourText="New to the console? The walkthrough drives the real screens and takes a minute."
    tourLabel="Take the tour"
    (tourRequested)="startTour()"
  />
</div>
